import { render } from "./Frame.vue?vue&type=template&id=55ea14e7&scoped=true&ts=true"
import script from "./Frame.vue?vue&type=script&lang=ts"
export * from "./Frame.vue?vue&type=script&lang=ts"

import "./Frame.vue?vue&type=style&index=0&id=55ea14e7&lang=scss&scoped=true"

import exportComponent from "/Users/wangkaining/Code/vue_code/newapps/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55ea14e7"]])

export default __exports__